var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 66,
    viewBox: "0 0 82 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.563 6H63.437C67.8054 6 69.3895 6.45485 70.9865 7.30895C72.5836 8.16305 73.8369 9.41642 74.691 11.0135C75.5452 12.6105 76 14.1946 76 18.563V47.437C76 51.8054 75.5452 53.3895 74.691 54.9865C73.8369 56.5836 72.5836 57.8369 70.9865 58.6911C69.3895 59.5452 67.8054 60 63.437 60H18.563C14.1946 60 12.6105 59.5452 11.0135 58.6911C9.41642 57.8369 8.16305 56.5836 7.30895 54.9865C6.45485 53.3895 6 51.8054 6 47.437V18.563C6 14.1946 6.45485 12.6105 7.30895 11.0135C8.16305 9.41642 9.41642 8.16305 11.0135 7.30895C12.6105 6.45485 14.1946 6 18.563 6Z",
    fill: "#CE82FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4258 18.0126C52.1825 17.8529 53.6971 19.2359 53.6973 20.9999V40.9999C53.6973 44.3136 51.011 46.9999 47.6973 46.9999C44.3836 46.9999 41.6973 44.3136 41.6973 40.9999C41.6973 37.6862 44.3836 34.9999 47.6973 34.9999C48.3986 34.9999 49.0717 35.1205 49.6973 35.3417V27.078L35.6973 28.3514V41.7147L35.6895 42.0233C35.529 45.1937 32.9076 47.7147 29.6973 47.7147C26.3836 47.7147 23.6973 45.0284 23.6973 41.7147C23.6974 38.4011 26.3837 35.7147 29.6973 35.7147C30.3987 35.7147 31.0716 35.8363 31.6973 36.0575V22.4549C31.6973 20.9033 32.8805 19.6071 34.4258 19.4667L50.4258 18.0126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 54,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.9883bc9a24ac01ae3920133fb827c752.svg";
export { ForwardRef as ReactComponent };